export enum XRTargetRayMode {
  Gaze,
  TrackedPointer,
  Screen
}
